import Big from 'big.js';
import fromExponential from 'from-exponential';

type DecimalNumberType = number | string | undefined;

export const decimalMinus = (...numbers: Array<DecimalNumberType>) => {
  const result = numbers.reduce((accumulator: Big | undefined, num: number | string | undefined) => {
    if (num === undefined) return accumulator;

    const value = new Big(fromExponential(num));

    if (accumulator === undefined) return value;

    return accumulator.minus(value);
  }, undefined);

  return result ?? new Big(0);
};

export const decimalAddition = (...numbers: Array<DecimalNumberType>): Big =>
  numbers.reduce((acc, num = 0) => acc.plus(fromExponential(Number(num) || 0) || 0), new Big(0));
